import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import QrReader from 'react-qr-reader';
import { Loading } from '../Loading.js';
import '../../tslib.es6-17e0406b.js';
import '@mui/material';

const PREFIX = 'QRCodeScanner';
const classes = {
    qrreader: `${PREFIX}-qrreader`,
    loading: `${PREFIX}-loading`,
};
const Root = styled('div')({
    [`& .${classes.qrreader}`]: {
        '& section > div': {
            'box-shadow': 'white 0px 0px 0px 2px inset !important',
        },
    },
    [`& .${classes.loading}`]: {
        marginBottom: '32px',
    },
});
const QRCodeScanner = ({ setOpen, setCode }) => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);
    const handleScan = (data) => {
        if (data) {
            setCode(data);
            setOpen(false);
        }
    };
    const handleError = (err) => {
        console.error(err);
    };
    return (jsx(Root, Object.assign({ sx: { mb: 1 } }, { children: loading ? (jsx(Loading, { className: classes.loading })) : (jsx(QrReader, { className: classes.qrreader, delay: 300, onError: handleError, onScan: handleScan, style: {
                height: '100%',
                width: '100%',
            } })) })));
};

export { QRCodeScanner };
